import {
  GET_PRICE_PREVIEW_REQUEST,
  GET_PRICE_PREVIEW_SUCCESS,
  GET_PRICE_PREVIEW_FAILURE,
  RESET_PRICE_PREVIEW
} from 'menus/constants/actionTypes';

import { apiAction } from 'base/utils/apiHelpers';
import { getProductPricePreviewEndpoint } from 'base/constants/endpoints';

/**
 * see the product price preview of a item.
 * payload - required_fields
 */
export const getProductPricePreview = (id, payload) => (dispatch, getState) => {
  const endpoint = getProductPricePreviewEndpoint(id);
  return dispatch(
    apiAction(
      endpoint,
      'POST',
      [
        GET_PRICE_PREVIEW_REQUEST,
        GET_PRICE_PREVIEW_SUCCESS,
        GET_PRICE_PREVIEW_FAILURE
      ],
      payload
    )
  );
};

export const resetProductPreview = () => {
  return {
    type: RESET_PRICE_PREVIEW
  };
};
